module.exports = __webpack_public_path__ + "static/code-053f0ea5fc48ed4343c0fc1f1a96d7c2.jpg";